import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {environment} from 'src/environments/environment';
import { UtilService } from './util';
import { EtiquetaMateriaPrimaFornecedor1 } from '../interface/etiqueta-materia-prima-fornecedor';

@Injectable({
  providedIn: 'root'
})
export class PcpEtiquetaService {
  url = `${environment.urlApiProtheus}/wsrpcpetiqueta`;

  constructor(
    private httpClient: HttpClient,
    private utilService: UtilService,
  ){}

  postPcpEtiquetaMateriaPrimaFornecedor1(dados: EtiquetaMateriaPrimaFornecedor1): Observable<any> {

    const httpOptions = this.utilService.filtrosHttpOptions();
    httpOptions.responseType = 'blob' as 'json';

    return this.httpClient.post(`${this.url}/materia-prima-fornecedor-1`,dados, httpOptions);
  }

}
